import React, {
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react';
import propTypes from 'prop-types';
import { validInitialTireQuantities } from './helpers';
import { createStorage } from '../../utilities/storage';
import { clamp } from '../../utilities/clamp';

const QuantityContext = createContext();

const QuantityProvider = ({ children }) => {
  const storage = createStorage('tireFinderQuantityData');

  const [quantities, setQuantities] = useState(() => {
    const { qty_front: qtyFront, qty_rear: qtyRear } = storage.get() ?? {};

    return validInitialTireQuantities({ qtyFront, qtyRear });
  });

  const setFront = (qty) => setQuantities((qtys) => ({ ...qtys, qtyFront: qty }));
  const setRear = (qty) => setQuantities((qtys) => ({ ...qtys, qtyRear: qty }));

  const updateQuantities = useCallback(
    ({
      isFrontTire, isSplitFitment, minQuantity, maxQuantity, newQuantity,
    }) => {
      let qty = newQuantity;
      if (Number.isNaN(qty)) {
        qty = minQuantity;
      } else if (qty !== '') {
        qty = clamp(qty, { min: minQuantity, max: maxQuantity });
      }

      if (!isSplitFitment || isFrontTire) {
        setFront(qty);
      } else {
        setRear(qty);
      }
    },
    [],
  );

  useEffect(() => {
    storage.set({
      qty_front: quantities.qtyFront === '' ? null : quantities.qtyFront,
      qty_rear: quantities.qtyRear === '' ? null : quantities.qtyRear,
    });
  }, [storage, quantities]);

  return (
    <QuantityContext.Provider
      value={{
        quantities,
        updateQuantities,
      }}
    >
      {children}
    </QuantityContext.Provider>
  );
};

QuantityProvider.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
  ]),
};

export { QuantityProvider, QuantityContext };
